import type { Effect } from "@skilitics/nautilus-core";
import type { EffectBuild } from "@skilitics/nautilus-core-designer-data";

import type { GetEffectBuildable } from "../../triggers/index.ts";
import type { ResolveValueToRuntimeDynamicValue } from "../../values/index.ts";

export const buildRuntimeEffectCreate =
  (getEffectBuildable: GetEffectBuildable, resolveRuntimeValue: ResolveValueToRuntimeDynamicValue) =>
  ({ nodeId, buildableName, config, targetNodeId }: EffectBuild): Effect | undefined => {
    const buildable = getEffectBuildable({ nodeId, name: buildableName });

    if (!buildable) {
      console.warn(`Buildable not found for effect: ${nodeId}:${buildableName}`);
      return undefined;
    }

    const { spec, builder } = buildable;

    return builder.build({
      targetNodeId: targetNodeId ?? nodeId,
      config,
      spec,
      nodeAction: (action) => ({
        type: "node-action",
        targetId: targetNodeId,
        action,
      }),
      // @ts-ignore the impl is untyped over the configured value's type name
      resolvableValue: resolveRuntimeValue,
    });
  };

export type BuildRuntimeEffect = ReturnType<typeof buildRuntimeEffectCreate>;
